import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/opt/build/repo/src/components/recommendations.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <p><strong parentName="p">{`For cashback sign-up bonuses:`}</strong></p>
    <ol>
      <li parentName="ol">{`Capital One Venture (it is a "travel" cards but there are ways to redeem the bonuses essentially for cash)`}</li>
      <li parentName="ol">{`US Bank Leverage Card`}</li>
      <li parentName="ol">{`US Bank Business Cash Rewards (\\$500)`}</li>
      <li parentName="ol">{`Cap One Spark Cash (6 months after Venture)`}</li>
      <li parentName="ol">{`Cap One Spark Miles (6 mo after Spark Cash)`}</li>
      <li parentName="ol">{`Capital One Savor (6 months after Spark)`}</li>
      <li parentName="ol">{`Wells Fargo Business Platinum`}</li>
      <li parentName="ol">{`Wells Fargo Propel World (avail. via phone application ONLY - call 1-800-932-6736) - has become sensitive to new accounts recently`}</li>
      <li parentName="ol">{`US Bank Altitude - make sure you're 0/6`}</li>
      <li parentName="ol">{`Citi Premier 50k (can do mortgage/student loan cashout) - make sure you're 0/6`}</li>
      <li parentName="ol">{`BoA cards - Premium Rewards and cards with \\$200+ cashback bonuses  - apply for 2 pers. and 1 biz in one day)`}</li>
      <li parentName="ol">{`Amex MR cards (start with a targeted 100k personal Plat) - with a Schwab Platinum, MRs can be redeemed to a Schwab account for 1.25 cents each`}</li>
      <li parentName="ol">{`HSBC Cards`}</li>
      <li parentName="ol">{`Amex BCP`}</li>
      <li parentName="ol">{`One-off CU credit cards with big bonuses - follow Doctor of Credit to stay informed`}</li>
    </ol>
    <p><strong parentName="p">{`For ongoing cashback earning`}</strong>{` (you'll probably want to grab several/most of these so you can be earning 3-5% on as much of your spending as possible):`}</p>
    <ol>
      <li parentName="ol">{`Amex BCP or BCE`}</li>
      <li parentName="ol">{`Discover It`}</li>
      <li parentName="ol">{`Chase Freedom (PC a CSP or CSR to this)`}</li>
      <li parentName="ol">{`US Bank Cash+`}</li>
      <li parentName="ol">{`Discover it Miles (1st year only)`}</li>
      <li parentName="ol">{`Alliant Visa Signature`}</li>
      <li parentName="ol">{`Fidelity 2% Visa or Citi DoubleCash (DC only worth it if it's a PC from a Citi TY Premier or AA with a 50k+ sign-up bonus)`}</li>
      <li parentName="ol">{`Citi Costco Visa (only worth it if it's a PC from a TY Premier or AA with a 50k+ sign-up bonus)`}</li>
      <li parentName="ol">{`Ink Cash`}</li>
    </ol>
    <p>{`Note that (like many banks) Capital One can be quite sensitive to the number of inquiries and/or new accounts, so check recent DPs for approvals before going for Capital One cards if you are sitting on a lot of new cards/inquiries in the past 24 months. Carrying a balance on other cards :/ also seems to help approval.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      